module.exports = __webpack_public_path__ + "49b4defa512620e58c78b6f2c5928c70.png";


//////////////////
// WEBPACK FOOTER
// ./src/addons/images/bg-image.png
// module id = 1350
// module chunks = 17